import type {
  OrderJourneyQueryVariables,
  OrderJourneyQueryResponse,
} from '../graphql/queries/orderJourney.generated';
import type { IControlSettingData } from '~/presentation/reports/common/type';

import { EReportControlId, ERFilterKey } from '~/presentation/reports/common/type';
import { OrderJourneyDocument } from '../graphql/queries/orderJourney.generated';
import { EReportSource } from '~/modules/report-analytic/types';
import { appFetcher } from '~/api/utils';

export const fetchOrderJourney = (variables: OrderJourneyQueryVariables) => {
  return appFetcher<OrderJourneyQueryResponse, OrderJourneyQueryVariables>(
    OrderJourneyDocument,
    variables,
  )();
};

export const getOrderJourneySource = (controlData?: IControlSettingData) => {
  if (!controlData) return;

  const isFilterByExperiment = controlData[EReportControlId.FILTER]?.value?.includes(
    ERFilterKey.EXPERIMENT,
  );
  const isFilterByPage = controlData[EReportControlId.FILTER]?.value?.includes(ERFilterKey.PAGE);

  if (isFilterByExperiment && isFilterByPage) return;

  if (isFilterByExperiment) return EReportSource.CAMPAIGN;
  if (isFilterByPage) return EReportSource.PAGE;
};
